import { useState } from "react";

export const useHandleDataHook = () => {
	const [data, setData] = useState([]);
	const [dataBackup, setDataBackup] = useState([]);
	const [searchText, setSearchText] = useState("");	
	const [filters, setFilters] = useState({});

	const setAllData = (pData = []) => {
		setData(pData);
		setDataBackup(pData);
	};

	const updateData = (id, dataToUpdate = {}) => {
		setDataBackup((prevBackup) =>
			prevBackup.map((item) => (item.id === id ? { ...item, ...dataToUpdate } : item))
		);
	
		setData((prevData) => {
			const updatedData = prevData.map((item) =>
				item.id === id ? { ...item, ...dataToUpdate } : item
			);
	
			return searchText ? updatedData.filter((item) => __checkObjectForMatch(item, searchText)) : updatedData;
		});
	};
	
	const updateMultipleData = (registersIdToUpdate = {}) => {
		const updatedBackup = dataBackup.map((item) =>
			registersIdToUpdate[item.id] ? { ...item, ...registersIdToUpdate[item.id] } : item
		);
	
		setDataBackup(updatedBackup);		
		__applyFilters(searchText, filters, updatedBackup);
	};

	const __applyFilters = (search, activeFilters, sourceData = dataBackup) => {
		let filteredData = [...sourceData];

		if (search.trim() !== "") {
			filteredData = filteredData.filter((item) => __checkObjectForMatch(item, search));
		}

		Object.entries(activeFilters).forEach(([property, value]) => {
			if (value === "") return; // Si el filtro está vacío, se ignora

			if (property === "payedState") {
				filteredData = filteredData.filter((item) => {
					const percentage = item.percentage || 0;
					if (value === "no") return percentage === 0;
					if (value === "intermediate") return percentage > 0 && percentage < 100;
					if (value === "completed") return percentage === 100;
					return true;
				});
			} else {
				filteredData = filteredData.filter((item) => item[property] === value);
			}
		});

		setData(filteredData);
	};
	
	const updateBackupData = () => {
		setDataBackup(data);
	};

	const addMoreData = (newData) => {
		setData([...data, ...newData]);
		setDataBackup([...data, ...newData]);
	};

	const resetDataToOriginal = () => {
		setData(dataBackup);
		setDataBackup(dataBackup);
	};
	
	const deleteSelectedData = (registersIdToDelete = []) => {
		setData((prevData) => prevData.filter((item) => !registersIdToDelete.includes(item.id)));
		setDataBackup((prevBackup) => prevBackup.filter((item) => !registersIdToDelete.includes(item.id)));
	};

	const clearAllData = () => {
		setData([]);
		setDataBackup([]);
	};

	const onChangeSearch = (text) => {
		if (typeof text !== "string") return;
	
		setSearchText(text);
		__applyFilters(text, filters);
	};

	const onFilterByProperty = (property, value) => {
		setFilters((prevFilters) => {
			const newFilters = { ...prevFilters, [property]: value };
			__applyFilters(searchText, newFilters);
			return newFilters;
		});
	};

	const __checkObjectForMatch = (obj, searchText) => {
		const matchesText = (str) => {
			if (typeof str === "string") {
				return str.toLowerCase().includes(searchText.toLowerCase());
			} else if (typeof str === "number") {
				return String(str).toLowerCase().includes(searchText.toLowerCase());
			}
			return false;
		};
	
		for (const key in obj) {
			if (matchesText(obj[key])) {
				return true;
			}
	
			if (typeof obj[key] === "object" && obj[key] !== null) {
				if (__checkObjectForMatch(obj[key], searchText)) {
					return true;
				}
			}
		}
		return false;
	};
	
	return {
		data,
		dataBackup,
		searchText,
		setAllData,
		updateData,
		updateMultipleData,
		updateBackupData,
		addMoreData,
		resetDataToOriginal,
		deleteSelectedData,
		clearAllData,
		onChangeSearch,
		onFilterByProperty,
	};
};